/**
 * Legacy re-export shim — `PortalPhoneInput` now delegates to
 * `components/shared/PhoneInput.jsx`. Kept as a thin wrapper so
 * existing portal call-sites don't break and the portal cream tint
 * on the input is preserved.
 */
import { AppPhoneInput } from '../shared/PhoneInput';

export const PortalPhoneInput = ({ testid = 'portal-phone-input', ...rest }) => (
    <AppPhoneInput
        {...rest}
        testid={testid}
        inputClassName="bg-[#FBF8F6] border-[#EFE5E1]"
    />
);

export default PortalPhoneInput;
